import { render, staticRenderFns } from "./RegistedTips.vue?vue&type=template&id=ef8b9794&scoped=true"
import script from "./RegistedTips.vue?vue&type=script&lang=js"
export * from "./RegistedTips.vue?vue&type=script&lang=js"
import style0 from "./RegistedTips.vue?vue&type=style&index=0&id=ef8b9794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8b9794",
  null
  
)

export default component.exports